$(document).ready(function () {
    'use strict';

/*
 * Gallery
 */

    if ($('.js_galleryOverlay').length) {
        $('.js_galleryOverlay').mtcOverlay({
            gallery: true,
            imageTitle: true,
            contentClass: 'showOverflow',
            video: true,
            videoSettings: {
                autoplay: false,
                width: 800,
                height: 450
            },
            buttonHtml: '<div class="videoCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
        });
    }

}); // document ready
